<app-modal>
    <form class="form">
        <div class="form_group">
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Сумма</div>
                <div class="col-17"><input [(ngModel)]="orderCancelForm.payment.amount" name="amount" type="number" class="inp"
                        placeholder="Введите сумму"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Валюта</div>
                <div class="col-17">
                    <input name="currency" type="text" disabled [value]="order.currency ? '$' : '€'" class="inp">
                </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">ID транзакции <span class="color_violet fz_xs">(не обязательно)</span></div>
                <div class="col-17"><input [(ngModel)]="orderCancelForm.payment.transactionId" name="transactionId" type="text" class="inp" placeholder="Введите id"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Причина отмены</div>
                <div class="col-17"><textarea [(ngModel)]="orderCancelForm.comment" placeholder="Введите причину" class="inp" name="comment"></textarea></div>
            </label>
        </div>
        <div class="btns_container row fw_500 fz_s">
            <button (click)="closeModal()" class="btn btn_cancel">Закрыть</button>
            <button (click)="orderCancel()" [disabled]="isLoadingSend" type="submit" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Отменить</span> </button>
        </div>
    </form>
</app-modal>